
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M54.862 33.169C54.082 32.39 53.137 32 52.025 32H21.32V18.651c0-2.949 1.043-5.466 3.129-7.552 2.087-2.086 4.603-3.129 7.552-3.129 2.948 0 5.464 1.043 7.55 3.129s3.129 4.603 3.129 7.552c0 .723.266 1.348.794 1.876.528.529 1.154.793 1.876.793h2.67c.725 0 1.351-.264 1.879-.793.526-.528.791-1.154.791-1.876 0-5.146-1.829-9.547-5.484-13.205C41.549 1.789 37.147-.04 32.002-.04c-5.146 0-9.548 1.829-13.205 5.486s-5.486 8.059-5.486 13.205V32h-1.335c-1.112 0-2.058.39-2.836 1.168-.779.779-1.169 1.725-1.169 2.837v24.029c0 1.114.39 2.06 1.169 2.836.778.779 1.724 1.168 2.836 1.168h40.05c1.111 0 2.059-.389 2.837-1.168.777-.776 1.167-1.722 1.167-2.836V36.006c-.001-1.112-.388-2.058-1.168-2.837z"}})])
          )
        }
      }
    